module.exports = __webpack_public_path__ + "static/media/WhatsApp Image 2021-04-02 at 5.15 1.4df19b9c.png";